import { CircularProgress, IconButton, ListItemText, Menu, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import alertTriangel from '../../../assets/alert-triangle.svg'
import { type ConnectedProps, connect } from 'react-redux'
import { type RootState } from '../../../store'
import { type DeviceListState } from '../../device-management/redux/deviceListSlice'
import { fetchDeviceList } from '../../device-management/redux/actionCreators'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../i18n/locales'

const GatewayStatus = (props: AllProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const assetTypeId = 'fdd42da4-4a13-4f57-9e1a-208d95c7f212'
  const [lastValue, setLastValue] = React.useState('')
  const AssetDashboardStrings = LanguageStrings().AssetDashboardStrings
  const handleGatewayStatusClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const open = Boolean(anchorEl)
  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const fetchGatewayStatus = (): void => {
    props.fetchDeviceList(
      props?.parentSiteId ?? '',
      assetTypeId,
      1,
      1000,
      '',
      '',
      props?.parentAssetId ?? '',
      ''
    )
  }
  const fetchGatewayStatusInterval = (): void => {
    if (!open) { fetchGatewayStatus() }
  }

  React.useEffect(() => {
    fetchGatewayStatus()
    const interval = setInterval(fetchGatewayStatusInterval, 60000)
    return () => {
      clearInterval(interval)
    }
  }, [props?.parentAssetId, props?.Golive])

  React.useEffect(() => {
    setLastValue('')
  }, [props?.parentAssetId])

  React.useEffect(() => {
    if (anchorEl !== null) { fetchGatewayStatus() }
  }, [anchorEl])

  React.useEffect(() => {
    if (!props?.deviceList?.isLoading) {
      const onlineDeviceList = props?.deviceList?.deviceList?.filter(e => e.communication_status === 'Online') ?? []
      if (onlineDeviceList?.length > 0) { setLastValue('Online') } else if (props?.deviceList?.deviceList?.length === 0) { setLastValue('No Devices') } else { setLastValue('Offline') }
    }
  }, [props?.deviceList?.deviceList])

  const [anchorElPopover, setAnchorElPopover] = React.useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorElPopover(event.currentTarget)
  }

  const handlePopoverClose = (): void => {
    setAnchorElPopover(null)
  }
  const openPopover = Boolean(anchorElPopover)
  return (
    <div
        style={{
          fontSize: '16px',
          textAlign: 'right',
          fontWeight: 'bold',
          marginTop: '10px',
          color: '#F0F0F0',
          textTransform: 'uppercase',
          letterSpacing: '2.5px'
        }}
        >
        {AssetDashboardStrings.AssetStatus} : &nbsp;
        {props?.deviceList?.isLoading && (<span className={`assetStatus ${lastValue?.toLocaleLowerCase()}`}>{lastValue} &nbsp;<CircularProgress /></span>)}
        {!props?.deviceList?.isLoading && (
          <span className={(props?.deviceList?.deviceList?.filter(e => e.communication_status === 'Online') ?? [])?.length > 0 ? 'online' : 'offline'} >
            {(props?.deviceList?.deviceList?.filter(e => e.communication_status === 'Online') ?? [])?.length > 0 ? 'Online' : props?.deviceList?.deviceList?.length === 0 ? 'No Devices' : 'Offline'}
            {/* Any one of device status offline means need to enable alert icon */}
            &nbsp;&nbsp;
            {((props?.deviceList?.deviceList?.filter(e => e.communication_status === 'Online') ?? [])?.length > 0 &&
             (props?.deviceList?.deviceList?.filter(e => e.communication_status === 'Offline') ?? [])?.length > 0)
              ? (<>
              <img src={alertTriangel}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                width={18} loading='lazy' alt="Alert: Some devices are offline" />
            <Popover
              id="mouse-over-popover"
              open={openPopover}
              anchorEl={anchorElPopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              onClose={handlePopoverClose}
              disableRestoreFocus
              sx={{
                pointerEvents: 'none',
                '& .MuiPaper-root': {
                  backgroundColor: '#404040',
                  color: '#fff',
                  marginTop: '15px',
                  fontFamily: 'Honeywell Sans Web'
                }
              }}
            >
              <Typography sx={{ p: 1 }}>Device Connectivity Alert</Typography>
            </Popover>
              </>)
              : (<></>)
            }
          </span>
        )}
        {props?.deviceList?.deviceList?.length !== 0 && (
            <IconButton onClick={handleGatewayStatusClick} style={{ paddingTop: 2 }}>
                <MoreVertIcon />
            </IconButton>
        )}

          <Menu
            anchorEl={anchorEl}
            MenuListProps={{ 'aria-labelledby': 'fade-button' }}
            open={open}
            onClose={handleClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            className='gatewayDeviceList'
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1
                },
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: '#404040',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0
                }
              }
            }}
            >
              {props?.deviceList?.isLoading
                ? (
                <MenuItem>
                  <ListItemText className='item-text' >
                    <span> Loading ... </span>
                  </ListItemText>
                </MenuItem>
                  )
                : (
                <>
                  {props?.deviceList?.deviceList?.map((item: any, index: number) => {
                    return (
                      <MenuItem key={index}>
                        <ListItemText className='item-text' style={{ textAlign: 'end' }} >
                          {item.name} &nbsp; :  &nbsp; <span style={{ fontSize: 16 }} className={String(item.communication_status)?.toLocaleLowerCase()} > {item.communication_status}</span>
                        </ListItemText>
                      </MenuItem>
                    )
                  })}
                  {props?.deviceList?.deviceList?.length === 0 && (
                    <MenuItem>
                        <ListItemText className='item-text' >
                          <span>No Devices</span>
                        </ListItemText>
                      </MenuItem>
                  )}
              </>
                  )}

            </Menu>

    </div>
  )
}

interface DispatchToProps {
  fetchDeviceList: (
    parentSiteId: string,
    assetTypeId: string,
    PageNumber: number,
    PageItems: number,
    searchKey: string,
    SortParams: string,
    parentAssetId: string,
    sortField: string
  ) => void
}
interface StateToProps {
  deviceList: DeviceListState
}
interface IGatewayProps {
  parentSiteId: string | undefined
  parentAssetTypeId: string | undefined
  parentAssetId: string | undefined
  Golive: any
}

const mapStateToProps = (state: RootState): StateToProps => ({
  deviceList: state.deviceManagementDeviceList
})

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchDeviceList: (
    parentSiteId: string,
    assetTypeId: string,
    PageNumber: number,
    PageItems: number,
    searchKey: string,
    SortParams: string,
    parentAssetId: string,
    sortField: string
  ) =>
    dispatch(
      fetchDeviceList(
        parentSiteId,
        assetTypeId,
        PageNumber,
        PageItems,
        searchKey,
        SortParams,
        parentAssetId,
        sortField
      )
    )
})

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type AllProps = PropsFromRedux & IGatewayProps
export const MemorizedGatewayStatus = React.memo(connector(GatewayStatus))
